import { Model } from "./model";

//import { Posm } from "./posm.model";

export class PosmItem extends Model {
    id: number;
    name: string;
    title: string;
    content: string;
    image?: string;
    image_url?: string;
    translation?: string;
    products: Array<any>;
}


// WEBPACK FOOTER //
// ./src/models/posm-item.model.ts